export const addMemberSteps = [
  {
    element: '.add-member-form',
    popover: {
      title: 'Add New Member',
      description: 'Use this form to create a new member for the selected client. Please fill in all required fields below.',
      position: 'top',
    },
  },
  {
    element: '.input-first-name',
    popover: {
      title: 'First Name',
      description: 'Enter the first name of the member you want to add.',
      position: 'right',
    },
  },
  {
    element: '.input-last-name',
    popover: {
      title: 'Last Name',
      description: 'Enter the last name of the member.',
      position: 'right',
    },
  },
  {
    element: '.input-email',
    popover: {
      title: 'Email Address',
      description: 'Provide a valid email address for the member. This will be used for login and communication.',
      position: 'right',
    },
  },
  {
    element: '.select-role',
    popover: {
      title: 'Assign Role',
      description: 'Select a role for the member, such as Admin,User based on the client’s access requirements.',
      position: 'right',
    },
  },
  {
    element: '.upload-profile-image',
    popover: {
      title: 'Upload Profile Image',
      description: 'Optionally upload a profile picture for the member.',
      position: 'right',
    },
  },
  {
    element: '.btn-submit-member',
    popover: {
      title: 'Create Member',
      description: 'Click here to add this member to the client’s account.',
      position: 'left',
    },
  },
  {
  element: '.settings',
  popover: {
    title: 'Connecting A Platform',
    description: "Ready to supercharge your tracking? Click on <b>Settings > Integrations </b> to easily connect your advertising and organic post platforms. This final step links your campaigns directly to University Intelligence, bringing all your marketing data into one place.",
    position: 'top',
  },
}
];
